import React, { PropsWithChildren, useEffect, useState } from 'react';
import { useIntl } from 'react-intl';
import { useStore } from 'react-redux';
import MainImageRendererFactoryContext from 'app/providers/ImageRenderer/MainImageRendererFactory/context';
import { MainImageRendererFactory } from 'app/adapters/MainImageRenderer';

export default function MainImageRendererFactoryProvider({ children }: PropsWithChildren<{}>) {
  const intl = useIntl();
  const store = useStore();
  const [rendererFactory] = useState(() => new MainImageRendererFactory(intl));

  useEffect(() => {
    rendererFactory.intl = intl;
  }, [intl]);
  useEffect(() => {
    rendererFactory.store = store;
  }, [store]);

  return (
    <MainImageRendererFactoryContext.Provider value={rendererFactory}>
      {children}
    </MainImageRendererFactoryContext.Provider>
  );
}
